import { categories } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            漫画分类
          </h3>
          <p className="text-sm text-foreground-500 mt-2">探索你喜欢的韩漫类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">{cat.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}